/**
 * Garde-fou anti open redirect pour toutes les navigations construites depuis
 * une entrée non fiable (`?redirectTo=`, fragment d'URL, retour SSO admin).
 *
 * Refuse :
 * - les URL absolues (`https://evil.tld`, `data:`, `javascript:`) ;
 * - les chemins protocol-relative (`//evil.tld`) ;
 * - tout antislash (`\evil.tld`, `/\evil.tld`) que les navigateurs normalisent
 *   en `/` — c'est le vecteur du bypass CVE-2025-68470 corrigé côté
 *   react-router 7.18.0 ;
 * - les pseudo-schémas glissés après un slash (`/javascript:alert(1)`).
 *
 * Retourne `fallback` (par défaut la racine) dès que la valeur n'est pas un
 * chemin interne strict.
 */
export function safeInternalPath(raw: string | null | undefined, fallback = '/'): string {
  if (!raw) return fallback;
  const value = raw.trim();
  if (!value.startsWith('/')) return fallback;
  if (value.startsWith('//')) return fallback;
  if (value.includes('\\')) return fallback;
  if (/^\/+[a-z][a-z0-9+.-]*:/i.test(value)) return fallback;
  return value;
}
